<footer class="footer border-top">
  <div
    class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between py-3 small"
  >
    <p class="text-muted mb-1 mb-md-0">
      Copyright © 2024
      <a href="https://www.idea-pa.it/" target="_blank">IdeaPA</a>
    </p>
    <p class="text-muted">{{ version }}</p>
  </div>
</footer>
